import { Decoration } from '@atlaskit/editor-prosemirror/view';
import { ProactiveDecorations } from './index';
var createDecoration = function createDecoration(from, to, id) {
  return Decoration.inline(from, to, {
    nodeName: 'span',
    class: "ai-proactive-recommendation",
    id: "ai-proactive-".concat(id),
    'data-testid': "ai-proactive-recommendation"
  }, {
    key: ProactiveDecorations.RECOMMENDATION,
    recommendationId: id
  });
};
export var updateRecommendationDecoration = function updateRecommendationDecoration(_ref) {
  var decorationSet = _ref.decorationSet,
    tr = _ref.tr,
    pluginState = _ref.pluginState;
  var proactiveAIBlocks = pluginState.proactiveAIBlocks;
  var allBlocksWithRecommendations = proactiveAIBlocks.filter(function (block) {
    var _block$recommendation;
    return !!(block !== null && block !== void 0 && (_block$recommendation = block.recommendations) !== null && _block$recommendation !== void 0 && _block$recommendation.length);
  });

  // NOTE: we only want 1 decoration per block regardless of how many recommendations there are.
  var currentIds = allBlocksWithRecommendations.map(function (block) {
    return block.id;
  });
  var existingIds = new Set();

  // First step: remove decorations for diffObjects that does not exist any more.
  // For performance reasons, we will build existingDecorationDiffObjectIds here as well.
  var decorationsToRemove = decorationSet.find(undefined, undefined, function (spec) {
    if (spec.key !== ProactiveDecorations.RECOMMENDATION) {
      return false;
    }
    existingIds.add(spec.recommendationId);
    return !currentIds.includes(spec.recommendationId);
  });
  decorationSet = decorationSet.remove(decorationsToRemove);

  // Second step: map existing decorations set with tr.mapping
  decorationSet = decorationSet.map(tr.mapping, tr.doc);

  // Third step: create new decorations for new diffObjects.
  var decorations = allBlocksWithRecommendations === null || allBlocksWithRecommendations === void 0 ? void 0 : allBlocksWithRecommendations.reduce(function (acc, _ref2) {
    var id = _ref2.id,
      from = _ref2.from,
      to = _ref2.to;
    if (!existingIds.has(id)) {
      acc.push(createDecoration(from, to, id));
    }
    return acc;
  }, []);

  // Fourth Step: If there are new decorations then add it in decorationsSet
  if (!!(decorations !== null && decorations !== void 0 && decorations.length)) {
    return decorationSet.add(tr.doc, decorations);
  }
  return decorationSet;
};